import { nipClient } from 'application/nip';
import { IFile } from 'types/dto';
import { handleCommandResponseData } from 'utils/net';

export async function uploadFile(files: FileList) {
  const formData = new FormData();

  Array.from(files).forEach((file: File) => {
    formData.append('files', file);
  });

  return nipClient
    .post('/files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(handleCommandResponseData<IFile[]>);
}
